<template>
  <div>
    <v-card-actions>
      <v-row>
        <v-col class="text-right">
          <v-btn
            :loading="loadingCheckin"
            x-large
            color="success"
            @click="sendCheckIn()"
          >
            Criar Avulsa
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
    <v-card-text>
      <v-row
        no-gutters
        class="mt-4"
      >
        <v-col>
          <AutocompleteSearchReserve
            v-model="reserve"
            @change="applyReserve"
          ></AutocompleteSearchReserve>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class=""
      >
        <v-col cols="3">
          <SelectRoom
            v-model="dataCheckIn.room"
            :errors="errors.room"
            @change="errors.room = null"
          >
          </SelectRoom>
        </v-col>
        <v-col
          cols="2"
          class="ml-4"
        >
          <v-switch
            v-model="onlyProducts"
            label="Somente Produtos/Serviços"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row
        v-if="onlyProducts == false"
        no-gutters
        justify="end"
      >
        <v-col cols="2">
          <vuetify-money
            v-model="dataCheckIn.accommodation_value"
            label="Valor da Hospedagem"
            disabled
            outlined
          ></vuetify-money>
        </v-col>
      </v-row>
      <v-row
        no-gutters
        class=""
      >
        <v-col
          cols="3"
          class="mr-2"
        >
          <SelectCategoryRoom
            v-model="dataCheckIn.room_category_id"
            :errors="errors.room_category_id"
            class="mr-4"
            @change="errors.room_category_id = ''"
          />
        </v-col>
        <v-col
          v-if="onlyProducts == false"
          cols="1"
          class="mr-2"
        >
          <v-switch
            v-model="dataCheckIn.tariff_manual"
            true-value="yes"
            false-value="not"
            label="Tarifa Manual"
          ></v-switch>
        </v-col>
        <v-col
          v-if="dataCheckIn.tariff_manual == 'not' && onlyProducts == false"
          cols=""
        >
          <SelectTariff
            v-model="dataCheckIn.tariff_id"
            :errors="errors.tariff_id"
            class="mr-4"
            @change="createTarif()"
            @object="setTariffObject"
          />
        </v-col>
        <v-col
          v-if="dataCheckIn.tariff_manual == 'yes' && onlyProducts == false"
          cols=""
        >
          <vuetify-money
            v-model="tariff_manual_value"
            :erros="errors.tariff_manual_value"
            outlined
            label="Tarifa"
            class="mr-4"
          />
        </v-col>
        <v-col
          cols=""
          class="ml-2"
        >
          <input-date
            v-model="dataCheckIn.check_in"
            :errors="errors.check_in"
            :dense="false"
            :label="'Check-in'"
            @change="errors.check_in = ''; createTarif()"
          ></input-date>
        </v-col>
        <v-col
          cols=""
          class="ml-2"
        >
          <input-date
            v-model="dataCheckIn.check_out"
            :errors="errors.check_out"
            :dense="false"
            :label="'Check-out'"
            @change="errors.check_out = ''; createTarif()"
          ></input-date>
        </v-col>
        <v-col v-if="onlyProducts == false">
          <v-btn
            color="primary"
            class="ml-4"
            @click="showDialogTariffExtraordinary"
          >
            <v-icon>{{ icons.mdiPencilOutline }}</v-icon>
            TARIFAS
          </v-btn>
        </v-col>
      </v-row>

      <v-row
        no-gutters
        class="mb-2"
      >
        <v-col
          cols="4"
          class="mr-2"
        >
          <v-select
            v-model="dataCheckIn.transport_type"
            :items="meiosTransporte"
            item-text="label"
            item-value="codigo"
            outlined
            label="Meio de Transporte"
            clearable
            hide-details
          />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="dataCheckIn.travel_reason"
            :items="motivosViagem"
            item-text="label"
            item-value="codigo"
            outlined
            label="Motivo da Viagem"
            clearable
            hide-details
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="6">
          <v-card outlined>
            <v-data-table
              dense
              :headers="headersgGuestUnknown"
              disable-sort
              :items="guest_unknown"
              :footer-props="{
                itemsPerPageText: 'Itens por pagina',
                itemsPerPageOptions: [5],
                showFirstLastPage: true,
              }"
            >
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col>
          <TableGuest
            v-model="guest"
            :errors="errors.guest"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <!-- DIALOG TARIFAS EXTRAORDINARIAS -->
    <v-dialog
      v-model="dialogTariffExtraordinary"
      persistent
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Tarifas"
          @close="dialogTariffExtraordinary = false"
        />
        <v-card-text>
          <!-- v-for=" tariff in editedItem.extraordinary_tariff   " -->
          <v-row
            v-for="tariff in extraordinary_tariff"
            no-gutters
            class="mb-2"
          >
            <v-col>
              <vuetify-money
                v-model="tariff.value"
                :option="{ prefix: 'R$' }"
                dense
                outlined
                hide-details
              ></vuetify-money>
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                readonly
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_start)"
                label="Data Inicio"
              ></v-text-field>
              <!-- <input-date css="ml-2" v-model="tariff.date_start" :label="'Data Inicial'" :dense="true"></input-date> -->
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                readonly
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_end)"
                label="Data Fim"
              ></v-text-field>
              <!-- <input-date css="ml-2" v-model="tariff.date_end" :label="'Data Final'" :dense="true"></input-date> -->
            </v-col>
            <!-- <v-col cols="1"> -->
            <!-- <v-btn icon color="error" class="ml-2" @click="removeTariffExtraordinary(tariff)" >
                            <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                        </v-btn> -->
            <!-- </v-col> -->
          </v-row>
          <!-- <v-row>
                    <v-col class="text-center"> -->
          <!-- <v-btn rounded  color="secondary" @click="addTariffExtraordinary()" >
                            <v-icon>{{ icons.mdiPlus }}</v-icon>
                            Adicionar Tarifa
                        </v-btn> -->
          <!-- </v-col>
                </v-row> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                text
                class="mr-4"
                @click="dialogTariffExtraordinary = false"
              >
                fechar
              </v-btn>
              <v-btn
                x-large
                color="primary"
                @click="confirmExtraordinaryTariff()"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiDeleteOutline, mdiPencilOutline, mdiPlus } from '@mdi/js'
import { mapActions, mapGetters } from 'vuex'
import AutocompleteSearchCompanyVue from '@/components/AutocompleteSearchCompany.vue'
import AutocompleteSearchReserve from '@/components/AutocompleteSearchReserve.vue'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import InputDate from '@/components/InputDate.vue'
import SelectCategoryRoom from '@/components/SelectCategoryRoom.vue'
import SelectTariff from '@/components/SelectTariff.vue'
import TableGuest from './TableGuest.vue'
import SelectRoom from '@/components/SelectRoom.vue'

export default {
  components: {
    AutocompleteSearchCompanyVue,
    InputDate,
    TableGuest,
    SelectTariff,
    SelectCategoryRoom,
    AutocompleteSearchReserve,
    BarTitleDialog,
    SelectRoom,
  },
  props: {

  },
  data: () => ({
    meiosTransporte: [],
    motivosViagem: [],
    dialogTariffExtraordinary: false,
    extraordinary_tariff: [],
    tariffObject: {},
    headersgGuestUnknown: [
      {
        text: 'HÓSPEDES',
        align: 'start',
        value: 'name',
      },
    ],
    audit: {},
    reserveTariff: false,
    loadingCheckin: false,
    guest: [],
    config: {},
    guest_unknown: [],
    company: null,
    reserve: null,
    dataCheckIn: {
      tariff_manual: 'not',
    },
    tariff_manual_value: '',
    onlyProducts: false,
    icons: {
      mdiDeleteOutline,
      mdiPlus,
      mdiPencilOutline,
    },
    errors: {
      room_category_id: null,
      tariff_id: null,
      check_in: null,
      check_out: null,
      company_id: null,
      guest: null,
      room: [],
    },
    tarifManualInitial: null, // parta da gambiarra
  }),
  watch: {
    tariff_manual_value(val) {
      // gambiarra pq o onchange no comoponenete vutify-money não funciona
      if (val != this.tarifManualInitial) {
        this.createTarif()
      }
    },
    room() {
      this.reserve = null
      this.dataCheckIn = {
        tariff_manual: 'not',
      }
      this.guest = []
      this.guest_unknown = []
      this.extraordinary_tariff = []
    },
    guest() {
      if (this.guest.length > 0) {
        this.errors.guest = ''
      }
    },
  },
  created() {
    this.config = this.loadConfig().then(response => {
      this.config = response.data
    })
    this.hasAudit().then(response => {
      this.audit = response.data
    })
    this.loadFnrhDominios()
  },
  computed: {
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),
    guests() {
      // fitrar os hospedes q estao cadastrados
      const guests = this.guest.filter(guest => guest.origin !== 'unknown')

      return guests
    },
  },
  methods: {
    ...mapActions('reserved', ['checkIn']),
    ...mapActions('config', ['loadConfig']),
    ...mapActions('audit', ['hasAudit']),
    ...mapActions('outstanding', ['createOutstanding']),
    ...mapActions('select', ['get_fnrh_dominios']),

    async loadFnrhDominios() {
      const [transport, reason] = await Promise.all([
        this.get_fnrh_dominios('meios_transporte'),
        this.get_fnrh_dominios('motivos_viagem'),
      ])
      this.meiosTransporte = transport.data
      this.motivosViagem = reason.data
    },

    setTariffObject(object) {
      this.tariffObject = object
      this.calcAccommodationValue()
    },
    showDialogTariffExtraordinary() {
      this.dialogTariffExtraordinary = true
    },
    addTariffExtraordinary() {
      this.extraordinary_tariff.push({ value: 0, date_start: '', date_end: '' })
    },
    removeTariffExtraordinary(tariff) {
      const index = this.extraordinary_tariff.indexOf(tariff)
      this.extraordinary_tariff.splice(index, 1)
    },

    applyReserve(reserve) {
      this.dataCheckIn.with_iss = reserve.with_iss
      const local = new Date(Date.now())
      const checkIn = new Date(this.dateConvert(local))
      this.dataCheckIn.check_in = checkIn.toISOString().split('T')[0]

      const check_out = new Date(reserve.check_out)

      if (this.dataCheckIn.check_in == reserve.check_in) {
        this.dataCheckIn.check_out = reserve.check_out
        this.reserveTariff = true
      }
      this.dataCheckIn.room_category_id = reserve.room_category_id
      this.dataCheckIn.tariff_manual = reserve.tariff_manual
      this.tariff_manual_value = reserve.tariff_manual_value
      this.tarifManualInitial = reserve.tariff_manual_value
      this.dataCheckIn.tariff_id = reserve.tariff_id
      this.tariffObject = reserve.tariff
      this.dataCheckIn.company_id = reserve.company_id
      this.guest = reserve.guest
      this.guest_unknown = reserve.guest_unknown
      this.extraordinary_tariff = reserve.extraordinary_tariff

      this.calcAccommodationValue()

      local.setHours(local.getHours() - 3)
    },
    createTarif() {
      if (this.onlyProducts) {
        return
      }
      this.reserveTariff = false
      const [hours, minutes] = this.config.checkout.split(':')
      this.errors.tariff_id = ''
      const local = new Date(Date.now())
      const checkIn = new Date(this.dateConvert(local))
      const checkOut = new Date(this.dataCheckIn.check_out)
      checkOut.setHours(checkOut.getHours() + 3)
      checkOut.setHours(hours)
      checkOut.setMinutes(minutes)
      this.dataCheckIn.check_in = checkIn.toISOString().split('T')[0]

      const diffInMs = checkOut - checkIn
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

      let value = 0

      if (this.dataCheckIn.tariff_manual == 'yes') {
        value = this.tariff_manual_value // this.dataCheckIn.tariff_manual_value
      } else {
        value = this.tariffObject.value
      }
      const tariffs = []
      let date_start = ''
      let date_end = ''
      if (diffInDays < 1 && diffInDays > 0) {
        date_start = checkIn.toISOString().split('T')[0]
        date_end = checkIn.toISOString().split('T')[0]
        tariffs.push({ value, date_start, date_end })
      } else if (diffInDays >= 1) {
        const temp_date = new Date()
        if (!this.audit.has_audit && temp_date.getHours() <= 10) {
          const date_start_e = checkIn.toISOString().split('T')[0]
          const date_end_e = checkIn.toISOString().split('T')[0]
          tariffs.push({ value, date_start: date_start_e, date_end: date_end_e })
        }
        for (let i = 1; i < diffInDays; i++) {
          date_start = checkIn.toISOString().split('T')[0]
          checkIn.setDate(checkIn.getDate() + 1)
          date_end = checkIn.toISOString().split('T')[0]
          tariffs.push({ value, date_start, date_end })
        }
      }

      this.extraordinary_tariff = tariffs
      this.calcAccommodationValue()
    },

    calcAccommodationValue() {
      let result = this.extraordinary_tariff.reduce((acc, tariff) => acc + parseFloat(tariff.value), 0)

      if (this.dataCheckIn.with_iss == 'yes') {
        // calc de iss
        if (result > 0) {
          const iss = result * this.issRate
          result += iss
        }
      }

      this.dataCheckIn.accommodation_value = result
    },

    confirmExtraordinaryTariff() {
      this.calcAccommodationValue()
      this.dialogTariffExtraordinary = false
    },
    sendCheckIn() {
      // Trigger para atualizar a data de checkin e checkout e as tariffs
      if (!this.reserveTariff) this.createTarif()

      // valida os dados
      if (!this.validations()) return

      this.dataCheckIn.onlyProducts = this.onlyProducts

      this.loadingCheckin = true
      this.dataCheckIn.guest = this.guests

      if (this.reserve) {
        this.dataCheckIn.reserve_id = this.reserve.id
      }

      this.dataCheckIn.accommodation_item = this.extraordinary_tariff

      this.createOutstanding(this.dataCheckIn)
        .then(response => {
          this.$toast.success('Avulsa criada com sucesso')
          this.$emit('close') // envia evento para fechar o dialog
          this.$emit('initialize') // envia o evento de checkin com os dados da avulsa criada
          this.dataCheckIn = {
            tariff_manual: 'not',
          }
          this.guest = []
          this.guest_unknown = []
          this.extraordinary_tariff = []
        })
        .catch(error => {
          this.$toast.error('Erro ao criar avulsa')
        })
        .finally(() => {
          this.loadingCheckin = false
        })
    },
    formatDate(date) {
      // const date = this.date
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },

    // Validacões
    validations() {
      let validate = true
      const [hours, minutes] = this.config.checkout.split(':')
      const checkIn = new Date(this.dataCheckIn.check_in)
      const checkOut = new Date(this.dataCheckIn.check_out)
      checkOut.setHours(checkOut.getHours() + 3)
      checkOut.setHours(hours)
      checkIn.setMinutes(minutes)

      if (!this.dataCheckIn.room) {
        this.errors.room = 'Campo obrigatório'
        validate = false
      }

      // valida a cetegoria do quarto
      if (this.dataCheckIn.room_category_id == null || this.dataCheckIn.room_category_id == undefined) {
        this.errors.room_category_id = 'Campo obrigatório'
        validate = false
      }

      if (this.onlyProducts == false) {
        // valida tarifa padrao
        if (this.dataCheckIn.tariff_manual == 'not') {
          // se estiver abilitado para tarifa padrao
          if (this.dataCheckIn.tariff_id == null || this.dataCheckIn.tariff_id == undefined) {
            this.errors.tariff_id = 'Campo obrigatório'
            validate = false
          }
        }

        // valida tarifa manual
        if (this.dataCheckIn.tariff_manual == 'yes') {
          // se estiver abilitado para tarifa padrao
          if (
            this.tariff_manual_value == null
            || this.tariff_manual_value == undefined
            || this.tariff_manual_value == 0
          ) {
            this.errors.tariff_manual_value = 'Campo obrigatório'
            validate = false
          }
        }

        // valida data checkout
        if (
          this.dataCheckIn.check_out == null
          || this.dataCheckIn.check_out == undefined
          || this.dataCheckIn.check_out == ''
        ) {
          this.errors.check_out = 'Campo obrigatório'
          validate = false
        }
        if (
          this.dataCheckIn.check_in == null
          || this.dataCheckIn.check_in == undefined
          || this.dataCheckIn.check_in == ''
        ) {
          this.errors.check_in = 'Campo obrigatório'
          validate = false
        }

        // valida se a checkout e maior q adata de checkin
        if (checkIn > checkOut) {
          this.errors.check_out = 'Data de checkout deve ser maior que a data atual'
          validate = false
        }
      }

      // valida se tem hopede ou empresa
      const guest = false

      if (this.guest.length == 0) {
        this.errors.guest = 'Obrigatório preencher hóspede'
        validate = false
      }

      return validate
    },

    dateConvert(date) {
      const dateStr = date.toLocaleString('pt-BR')
      let split = dateStr.split(',')
      split = split[0].split('/')

      return `${split[2]}-${split[1]}-${split[0]}`
    },
  },
}
</script>
